import React from 'react';
import { FileTextIcon, UploadCloudIcon, ZapIcon, CheckCircle2Icon } from 'lucide-react';
type Props = {
  filled: number;
  total: number;
  fileName: string;
};
export function TopBar({
  filled,
  total,
  fileName
}: Props) {
  const remaining = total - filled;
  const pct = Math.round(filled / total * 100);
  return <header className="border-b border-white/5 bg-[#0e0e12]/80 backdrop-blur-sm" data-id="element-107">
      <div className="px-6 py-3 flex items-center gap-6" data-id="element-108">
        {/* Brand */}
        <div className="flex items-center gap-2.5 shrink-0" data-id="element-109">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-violet-700 flex items-center justify-center shadow-[0_0_18px_rgba(167,139,250,0.45)]" data-id="element-110">
            <ZapIcon className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-111" />
          </div>
          <div className="leading-tight" data-id="element-112">
            <div className="text-[15px] font-semibold tracking-tight" data-id="element-113">
              QuickPDF
            </div>
            <div className="text-[10px] text-violet-300/70 font-mono uppercase tracking-wider" data-id="element-114">
              Done in 60 seconds
            </div>
          </div>
        </div>

        {/* Upload chip (subtle top state) */}
        <button className="group flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/[0.03] border border-white/5 hover:border-violet-400/40 hover:bg-violet-400/5 transition-colors" data-id="element-115">
          <FileTextIcon className="w-3.5 h-3.5 text-violet-300/80" data-id="element-116" />
          <span className="text-xs text-zinc-300 max-w-[180px] truncate" data-id="element-117">
            {fileName}
          </span>
          <span className="w-px h-3 bg-white/10" data-id="element-118" />
          <UploadCloudIcon className="w-3.5 h-3.5 text-zinc-500 group-hover:text-violet-300 transition-colors" data-id="element-119" />
          <span className="text-[11px] text-zinc-500 group-hover:text-violet-300 transition-colors" data-id="element-120">
            Replace
          </span>
        </button>

        {/* Field detection status + progress */}
        <div className="flex-1 flex items-center gap-4 min-w-0" data-id="element-121">
          <div className="flex items-center gap-3 text-[12px] font-mono whitespace-nowrap" data-id="element-122">
            <span className="flex items-center gap-1.5 text-zinc-300" data-id="element-123">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-400 dot-pulse" data-id="element-124" />
              {total} fields detected
            </span>
            <span className="text-zinc-600" data-id="element-125">•</span>
            <span className="flex items-center gap-1.5 text-emerald-300/90" data-id="element-126">
              <CheckCircle2Icon className="w-3 h-3" data-id="element-127" /> {filled} filled
            </span>
            <span className="text-zinc-600" data-id="element-128">•</span>
            <span className="text-zinc-400" data-id="element-129">{remaining} remaining</span>
          </div>

          <div className="flex-1 max-w-md" data-id="element-130">
            <div className="relative h-1.5 rounded-full bg-white/5 overflow-hidden" data-id="element-131">
              <div className="relative h-full rounded-full bg-gradient-to-r from-violet-500 to-violet-300 shimmer transition-all duration-500" style={{
              width: `${pct}%`
            }} data-id="element-132" />
            </div>
          </div>
          <span className="text-[11px] font-mono text-violet-300 tabular-nums" data-id="element-133">
            {pct}%
          </span>
        </div>
      </div>
    </header>;
}